import { faEdit, faLock, faLockOpen, faSave, faTrash, faExclamationCircle} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useContext, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { Handle, useReactFlow, useStoreApi, Position } from 'reactflow';
import AppContext from '../../../contexts/AppContext'

function MBarrier({ id, data }) {
  const [lockedByUsername, setLockedByUsername] = useState(data.lockedByUsername)
  const [text, setText] = useState(data.text)
  const { user, openModal } = useContext(AppContext);
  const keys = Object.keys(data.handles);

  useEffect(() => {
    setLockedByUsername(data.lockedByUsername)
  }, [data.lockedByUsername])

  useEffect(() => {
    setText(data.text)
  }, [data.text])

  return (
    <>
      <div className="custom-node__header-barrier rounded-[6px] bg-zinc-200 flex justify-between items-center">
        <strong>Mitigation</strong>
        
        <div data-tooltip-content={`Effectiveness (${data.computedEffect ? 'estimated' : 'not estimated'})`} data-tooltip-id='Effectiveness' 
        onClick={ data.disabled ? undefined :() => { data.showMBarrierModal() }}
        aria-disabled={data.disabled}
        className={`text-white ml-2 px-[4px] rounded cursor-pointer
          ${data.disabled ? 'cursor-not-allowed opacity-50 pointer-events-none'
                       : 'cursor-pointer'}
          ${data.computedEffect ? 'bg-gradient-to-r from-purple-700/90 to bg-purple-400' : 'bg-gray-600'}`}>
            <span className='text-md' >mE</span>
            {/* <FontAwesomeIcon icon={faExclamationCircle} size='md' /> */}
        </div>
        <Tooltip place='top' id='Effectiveness' />

        {/* <div className='text-[8px] font-semibold lowercase ml-auto'>Node-{id}</div> */}
        <div className='flex justify-between items-center'>
          <div
            onClick={() => {
              openModal("Delete Barrier?",
                `Are you sure you want to delete barrier "${id}"`,
                () => { data.delete(id, data.nfor) }
              )
            }}
            className='text-red-600 bg-white ml-2 px-[4px] rounded cursor-pointer'>
            <FontAwesomeIcon icon={faTrash} size='sm' />
          </div>
          <div className="custom-node__header-barrier bg-zinc-200 flex justify-between">
            {lockedByUsername ?
              <div><span className='text-[8px] bg-gray-100 px-1 rounded lowercase'><FontAwesomeIcon icon={faLock} /> <span className='ml-1'>{lockedByUsername == user?.sub ? 'you' : data.lockedByUsername}</span></span> </div>
              : <><div data-tooltip-content={'Edit/Lock'} data-tooltip-id='edit' onClick={async () => {
                const status = await data.acquireLock();
                if (status == 200) {
                  setLockedByUsername(user.sub)
                }
              }} className='text-slate-600 bg-white ml-2 px-[4px] rounded cursor-pointer'>
                <FontAwesomeIcon icon={faEdit} size='sm' />
              </div>
                <Tooltip place='top' id='edit' /></>}

            {(lockedByUsername === user?.sub) &&
              <>
                <div data-tooltip-content={'Save'} data-tooltip-id='save' onClick={() => data.update(text)} className='text-teal-600 bg-white ml-2 px-[4px] rounded cursor-pointer'>
                  <FontAwesomeIcon icon={faSave} size='sm' />
                </div>
                <Tooltip place='top' id='save' />
              </>
            }
          </div>
        </div>
      </div>
     
      <div className=''>
        <textarea
          value={text}
          disabled={(lockedByUsername !== user?.sub)}
          onChange={(e) => { data.text = e.currentTarget.value; setText(data.text); }}
          placeholder={'Mitigation description'}
          rows={"4"} className="shadow bg-white appearance-none border rounded-b-md w-full py-2 px-3 text-gray-700 
            leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
      <Handle type="source" position={Position.Left} id="handle-left" />
      <Handle type="target" position={Position.Right} id="handle-right" />
    </>
  );
}

export default memo(MBarrier);
